import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import { Redirect } from "react-router-dom";


const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 440,
  },
});

export default function ServiceTable(props) {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rows, setRow] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  if (localStorage.getItem("token") == null) return <Redirect to="/login" />;

  return (
    <div style={{ marginTop: "10px" }}>
      <Paper className={classes.root}>
        <TableContainer className={classes.container}>
          <Table responsive className="table border shadow">
            <thead class="thead-dark">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Theme</th>
                <th scope="col">Contact Person</th>
                <th scope="col">Contact Details</th>
                <th scope="col">State</th>
                <th scope="col">City</th>
                <th scope="col">Other Details</th>
              </tr>
            </thead>
            <tbody>
              {props.data.map((user, index) => (
                <tr>
                  <th scope="row">{index + 1}</th>
                  <td>{user.theme}</td>
                  <td>{user.name}</td>
                  <td>{user.phone}</td>
                  <td>{user.state}</td>
                  <td>{user.city}</td>
                  <td>{user.comment}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}
